import { AffectedStaff } from '../../lib/types/models/affectedStaff/affected-staff'
import { AffectedStaffRequestInput } from '../../lib/types/models/affectedStaff/affected-staff-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateAffectedStaff({
  id,
  ...rest
}: UpdateInput<Omit<AffectedStaffRequestInput, 'status'>>) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.update.url, { id }))
    .patch<AffectedStaff, Partial<AffectedStaffRequestInput>>(rest)
}
